import { createPortal } from "react-dom";
import { X } from "lucide-react";
import { getAppPortalRoot } from "../utils/appPortal";
import "./PotionExchangeModal.css";

export default function DemiLuneConfirmModal({
  open,
  forDateLabel,
  busy = false,
  error = "",
  onConfirm,
  onClose,
}) {
  if (!open) return null;

  return createPortal(
    <div
      className="potion-exchange-modal-backdrop"
      role="presentation"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <div
        className="potion-exchange-modal demi-lune-confirm"
        role="dialog"
        aria-modal="true"
        aria-labelledby="demi-lune-confirm-title"
      >
        <button
          type="button"
          className="potion-exchange-modal__close"
          onClick={onClose}
          disabled={busy}
          aria-label="Fermer"
        >
          <X size={18} strokeWidth={2.5} />
        </button>
        <h3 id="demi-lune-confirm-title" className="potion-exchange-modal__title">
          Philtre de la demi-lune
        </h3>
        <p className="potion-exchange-modal__text">
          Le philtre prendra effet sur la quête du <strong>{forDateLabel}</strong> :
          50&nbsp;% de chance d'y découvrir une relique. Il sera consommé
          maintenant.
        </p>
        {error ? <p className="potion-exchange-modal__error">{error}</p> : null}
        <div className="potion-exchange-modal__actions">
          <div className="potion-exchange-modal__actions-primary">
            <button
              type="button"
              className="potion-exchange-modal__btn potion-exchange-modal__btn--cancel"
              onClick={onClose}
              disabled={busy}
            >
              Annuler
            </button>
            <button
              type="button"
              className="potion-exchange-modal__btn potion-exchange-modal__btn--confirm"
              onClick={onConfirm}
              disabled={busy}
            >
              {busy ? "Préparation…" : "Utiliser"}
            </button>
          </div>
        </div>
      </div>
    </div>,
    getAppPortalRoot()
  );
}
